module.exports = __webpack_public_path__ + "static/media/uptone.4d160133.png";